import cookies from "js-cookie";

export default {
    data() {
        return {
            cookiesAccepted: false
        }
    },

    created() {
        if (cookies.get('acceptCookies') === 'yes') {
            this.cookiesAccepted = true;
        }
    },

    methods: {
        acceptCookies() {
            cookies.set('acceptCookies', 'yes', { expires: 365 });
            this.cookiesAccepted = true;
        },
    },
}



// WEBPACK FOOTER //
// ./assets/js/components/CookieBanner.js